import React from "react";
import { Header, Flex, Text, Input } from "@fluentui/react-northstar";
import { Row, Col } from "react-grid-system";
import { LabelElement } from "../shared/components/TicketForm";
import { toTitleCase } from "../shared/utils/helper";

export interface UserInfoField {
  key: string;
  label: string;
  required?: boolean;
  error?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  colSize?: number;
  disabled?: boolean;
}

export interface UserInfoSectionProps {
  title: string;
  fields: UserInfoField[];
  className?: string;
  viewMode?: boolean;
}

/**
 * Reusable component for rendering a user information section.
 * Organizes fields in a two-column grid layout in both edit and view modes.
 */
export const UserInfoSection: React.FC<UserInfoSectionProps> = ({
  title,
  fields,
  className = "mt-2",
  viewMode = false
}) => {
  const fieldPairs = [];
  for (let i = 0; i < fields.length; i += 2) {
    fieldPairs.push(fields.slice(i, i + 2));
  }

  return (
    <>
      <Header
        as="h3"
        content={<Text weight="semibold" size="large" content={title} />}
      />
      <Flex column gap="gap.small" className={className}>
        {fieldPairs.map((pair, rowIndex) => (
          <Row key={`row-${rowIndex}`}>
            {pair.map((field) => (
              <Col key={field.key} lg={field.colSize || 4}>
                {viewMode ? (
                  <div>
                    <Text weight="semibold" content={toTitleCase(field.label)} />
                    <div className="mt-1">
                      <Text content={field.value || "-- --"} />
                    </div>
                  </div>
                ) : (
                  <>
                    <LabelElement
                      label={toTitleCase(field.label)}
                      required={field.required}
                    />
                    <div className="teams-input-med">
                      <Input
                        clearable
                        inverted
                        disabled={field.disabled}
                        name={field.key}
                        value={field.value}
                        error={!!field.error}
                        onChange={(_e, p) => field.onChange(p.value)}
                        onBlur={field.onBlur}
                        fluid
                      />
                      {field.error && <Text error content={field.error} />}
                    </div>
                  </>
                )}
              </Col>
            ))}
          </Row>
        ))}
      </Flex>
    </>
  );
};
